export type AcceptTeamInviteRoute = {
  path: 'accept-team-invite';
  token: string;
};

export function maybeParseAcceptTeamInviteRoute(
  url: Pick<URL, 'searchParams' | 'pathname'>,
): AcceptTeamInviteRoute | undefined {
  if (url.pathname === '/app/accept-team-invite') {
    const token = url.searchParams.get('token') || '';
    return { path: 'accept-team-invite', token };
  }
}
